import React, { useEffect, useState } from "react";
import axios from "axios";

const WhyChooseUsBox = () => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [form, setForm] = useState({
    main_title: "",
    main_description: "",
    main_button_text: "",
    main_button_link: "",
    main_image: null,
    main_image_preview: "",
    child_items: [
      { child_title: "", child_description: "", child_image: null, child_image_preview: "" },
      { child_title: "", child_description: "", child_image: null, child_image_preview: "" },
      { child_title: "", child_description: "", child_image: null, child_image_preview: "" },
    ],
  });

  const fetchWhyChooseUs = async () => {
    try {
      setLoading(true);
      setMessage("");
      setError("");

      const res = await axios.get(
        "https://eventscons.com/eventbackendnew/api/why-choose-us-details"
      );

      const apiData = res?.data?.data;

      setForm({
        main_title: apiData?.main_title || "",
        main_description: apiData?.main_description || "",
        main_button_text: apiData?.main_button_text || "",
        main_button_link: apiData?.main_button_link || "",
        main_image: null,
        main_image_preview: apiData?.main_image || "",
        child_items:
          apiData?.child_items?.length > 0
            ? apiData.child_items.map((item) => ({
                child_title: item?.child_title || "",
                child_description: item?.child_description || "",
                child_image: null,
                child_image_preview: item?.child_image || "",
              }))
            : [
                {
                  child_title: "",
                  child_description: "",
                  child_image: null,
                  child_image_preview: "",
                },
                {
                  child_title: "",
                  child_description: "",
                  child_image: null,
                  child_image_preview: "",
                },
                {
                  child_title: "",
                  child_description: "",
                  child_image: null,
                  child_image_preview: "",
                },
              ],
      });
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to load Why Choose Us data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWhyChooseUs();
  }, []);

  const handleMainChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleMainImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setForm((prev) => ({
      ...prev,
      main_image: file,
      main_image_preview: URL.createObjectURL(file),
    }));
  };

  const handleChildChange = (index, field, value) => {
    const updated = [...form.child_items];
    updated[index][field] = value;

    setForm((prev) => ({
      ...prev,
      child_items: updated,
    }));
  };

  const handleChildImageChange = (index, file) => {
    if (!file) return;

    const updated = [...form.child_items];
    updated[index].child_image = file;
    updated[index].child_image_preview = URL.createObjectURL(file);

    setForm((prev) => ({
      ...prev,
      child_items: updated,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);
      setMessage("");
      setError("");

      const formData = new FormData();
      formData.append("main_title", form.main_title);
      formData.append("main_description", form.main_description);
      formData.append("main_button_text", form.main_button_text);
      formData.append("main_button_link", form.main_button_link);

      if (form.main_image) {
        formData.append("main_image", form.main_image);
      }

      form.child_items.forEach((item, index) => {
        formData.append(`child_titles[${index}]`, item.child_title);
        formData.append(`child_descriptions[${index}]`, item.child_description);

        if (item.child_image) {
          formData.append(`child_images[${index}]`, item.child_image);
        }
      });

      const res = await axios.post(
        "https://eventscons.com/eventbackendnew/api/why-choose-us-save",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMessage(res?.data?.message || "Why Choose Us updated successfully");
      fetchWhyChooseUs();
    } catch (err) {
      setError(err?.response?.data?.message || "Update failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <div style={styles.headerRow}>
          <div>
            <h2 style={styles.heading}>Why Choose Us</h2>
            <p style={styles.subHeading}>
              Edit main section and child items for the "Why Choose Us" block.
            </p>
          </div>
        </div>

        {message && <p style={styles.success}>{message}</p>}
        {error && <p style={styles.error}>{error}</p>}

        <div style={styles.card}>
          <div style={styles.form}>
            {loading ? (
              <p style={styles.loading}>Loading...</p>
            ) : (
              <form onSubmit={handleSubmit}>
                <div style={styles.imageBox}>
                  <label style={styles.label}>Main Image</label>

                  {form.main_image_preview ? (
                    <img
                      src={form.main_image_preview}
                      alt="Main Preview"
                      style={styles.mainimage}
                    />
                  ) : (
                    <div style={styles.noImageBox}>No image selected</div>
                  )}

                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleMainImageChange}
                    style={styles.input}
                  />
                </div>

                <div style={styles.field}>
                  <label style={styles.label}>Main Title</label>
                  <input
                    type="text"
                    name="main_title"
                    value={form.main_title}
                    onChange={handleMainChange}
                    style={styles.input}
                    placeholder="Enter main title"
                  />
                </div>

                <div style={styles.field}>
                  <label style={styles.label}>Main Description</label>
                  <textarea
                    name="main_description"
                    value={form.main_description}
                    onChange={handleMainChange}
                    rows="4"
                    style={styles.textarea}
                    placeholder="Enter main description"
                  />
                </div>

                <div style={styles.field}>
                  <label style={styles.label}>Main Button Text</label>
                  <input
                    type="text"
                    name="main_button_text"
                    value={form.main_button_text}
                    onChange={handleMainChange}
                    style={styles.input}
                    placeholder="Enter button text"
                  />
                </div>

                <div style={styles.field}>
                  <label style={styles.label}>Main Button Link</label>
                  <input
                    type="text"
                    name="main_button_link"
                    value={form.main_button_link}
                    onChange={handleMainChange}
                    style={styles.input}
                    placeholder="Enter button URL"
                  />
                </div>

                <h3 style={styles.subHeading}>Child Items</h3>

                {form.child_items.map((item, index) => (
                  <div key={index} style={styles.childItem}>
                    <div style={styles.field}>
                      <label style={styles.label}>Right Icon box {index + 1}</label>
                      <input
                        type="text"
                        value={item.child_title}
                        onChange={(e) =>
                          handleChildChange(index, "child_title", e.target.value)
                        }
                        style={styles.input}
                        placeholder={`Child title ${index + 1}`}
                      />
                    </div>

                    <div style={styles.field}>
                      <label style={styles.label}>Right Icon box Description {index + 1}</label>
                      <textarea
                        rows="3"
                        value={item.child_description}
                        onChange={(e) =>
                          handleChildChange(index, "child_description", e.target.value)
                        }
                        style={styles.textarea}
                        placeholder={`Child description ${index + 1}`}
                      />
                    </div>

                    <div style={styles.field}>
                      <label style={styles.label}>Right Icon box Image {index + 1}</label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          handleChildImageChange(index, e.target.files[0])
                        }
                        style={styles.input}
                      />
                      {item.child_image_preview && (
                        <img
                          src={item.child_image_preview}
                          alt={`Child Preview ${index + 1}`}
                          style={styles.image}
                        />
                      )}
                    </div>
                  </div>
                ))}

                <button type="submit" style={styles.button} disabled={saving}>
                  {saving ? "Saving..." : "Update Why Choose Us"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

// Exactly same design style as your TeamMembersEditor
const styles = {
  section: {
    padding: "40px 20px",
    border: "1px solid #eee",
    background: "#fff",
    margin: "30px",
    boxShadow: "0px 10px 25px #dcdcdc",
    borderRadius: "15px",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    marginBottom: "25px",
    flexWrap: "wrap",
  },
  heading: {
    margin: 0,
    fontSize: "28px",
    fontWeight: "700",
    color: "#000",
    textAlign: "left",
  },
  subHeading: {
    margin: "8px 0 0 0",
    color: "#6b7280",
    fontSize: "15px",
    fontWeight: "500",
  },
  card: {
    background: "#fff",
    borderRadius: "14px",
    border: "1px solid #efefef",
    padding: "16px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  },
  imageBox: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  image: {
    width: "10%",
    padding:"20px",
    objectFit: "cover",
    borderRadius: "10px",
    border: "1px solid #ddd",
    background:"#000",
  },
  mainimage: {
    width: "100%",
    height:"260px",
    
    objectFit: "cover",
    borderRadius: "10px",
    border: "1px solid #ddd",
    background:"#000",
  },
  noImageBox: {
    height: "180px",
    border: "1px dashed #bbb",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#666",
    background: "#fafafa",
    fontWeight: "500",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontWeight: "600",
    color: "#333",
  },
  input: {
    padding: "12px 14px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "15px",
    width: "100%",
    boxSizing: "border-box",
  },
  textarea: {
    padding: "12px 14px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "15px",
    resize: "vertical",
    width: "100%",
    boxSizing: "border-box",
  },
  button: {
    padding: "14px 20px",
    background: "#9B1321",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    marginTop:'10px',
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    width: "fit-content",
  },
  childItem: {
    padding: "16px",
    border: "1px solid #efefef",
    borderRadius: "10px",
    background: "#ffbebe94",
    marginTop: "16px",
  },
  success: {
    color: "green",
    fontWeight: "600",
  },
  error: {
    color: "red",
    fontWeight: "600",
  },
  loading: {
    textAlign: "center",
  },
};

export default WhyChooseUsBox;